import { PlayerManagementService } from './playermanagement.service';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

export interface LogEntry {
  time: Date;
  source: string;
  level: string;
  value: string;
}


@Injectable()
export class PlayerLogService {

  public addToLogArray = false;

  public logToConsole = false;
  public maxLogLength = 200;




  // display log vars
  public scheduleLog: LogEntry[] = [];
  public playerLog: LogEntry[] = [];
  public hostProcessLog: LogEntry[] = [];
  public errorsLog: LogEntry[] = [];
  public generalLog: LogEntry[] = [];

  public logSubject = new Subject<LogEntry>();


  constructor(public pms: PlayerManagementService) { }

  addToLog(level: string, source, ...args: any[]) {

    let argStr = '';
    if (args) {
      argStr = JSON.stringify(args);
    }
    // create logEntry
    const newLogEntry: LogEntry = { level: level, time: new Date(), source: source, value: argStr };


    this.logSubject.next(newLogEntry);


    if (!this.addToLogArray) {
      return;
    }


    // put all errors in the error log
    if (level === 'error') {

      this.errorsLog.push(newLogEntry);
      while (this.errorsLog.length > this.maxLogLength) {
        this.errorsLog.shift();
      }

    }

    switch (source) {
      case 'schedule':
        this.scheduleLog.push(newLogEntry);
        while (this.scheduleLog.length > this.maxLogLength) {
          this.scheduleLog.shift();
        }
        break;
      case 'player':
        this.playerLog.push(newLogEntry);
        if (this.playerLog.length > this.maxLogLength) {
          this.playerLog.shift();
        }
        break;
      case 'hostprocess':
        this.hostProcessLog.push(newLogEntry);
        while (this.hostProcessLog.length > this.maxLogLength) {
          this.hostProcessLog.shift();
        }
        break;
      case 'general':
        this.generalLog.push(newLogEntry);
        while (this.generalLog.length > this.maxLogLength) {
          this.generalLog.shift();
        }
        break;

      default:
        break;
    }



  }

  // default log level is info
  log(targetLog, ...args: any[]) {
    if (this.logToConsole) {
      console.log.apply(console, args);
    }
    this.addToLog('info', targetLog, args);

    this.pms.sendLog(targetLog, 'info', args);
  }

  trace(targetLog, ...args: any[]) {
    if (this.logToConsole) {
      console.log.apply(console, args);
    }
    this.addToLog('trace', targetLog, args);

    this.pms.sendLog(targetLog, 'trace', args);
  }

  debug(targetLog, ...args: any[]) {
    if (this.logToConsole) {
      console.log.apply(console, args);
    }
    this.addToLog('debug', targetLog, args);

    this.pms.sendLog(targetLog, 'debug', args);
  }

  info(targetLog, ...args: any[]) {
    if (this.logToConsole) {
      console.info.apply(console, args);
    }
    this.addToLog('info', targetLog, args);
    this.pms.sendLog(targetLog, 'info', args);
  }

  error(targetLog, ...args: any[]) {
    if (this.logToConsole) {
      console.error.apply(console, args);
    }
    this.addToLog('error', targetLog, args);
    this.pms.sendLog(targetLog, 'error', args);
  }



}



// WEBPACK FOOTER //
// ./src/app/player/services/PlayerLog.service.ts